// @flow
export const LOADING_SPINNER_API = {
  root: '',
  small: '',
  big: ''
};
